/**
 * Local storage
 */
export class StorageServices {
  static getData(key: string): string {
    try {
      const jsonData = localStorage.getItem(key);
      if (jsonData) {
        return jsonData;
      }
      return '';
    } catch (err) {
      return '';
    }
  }

  static setData(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (err) {
      return false;
    }
  }

  static removeData(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (err) {
      return false;
    }
  }
}
